import { assert } from '@deqo/foundation';
import { injectable } from 'inversify';
import { ContentPayload } from './ContentPayload';
import { ContentProcessor } from './ContentProcessor';

@injectable()
export class SerializedDeqoDataProcessor implements ContentProcessor {

    public readonly supportedTypes = Object.freeze([
        'x/deqo-data',
    ]);

    public async process({ data }: ContentPayload): Promise<boolean | ContentPayload> {

        // Unpack from either tuple, json or blob json
        data = await this.unpackData(data);
        assert(!!data, 'SerializedDeqoDataProcessor: input must be tuple, json string or blob json string.');

        return ContentPayload.create('x/deqo-tuple', data);
    }

    private async unpackData(data: any) {
        // Already tuple
        if (Array.isArray(data)) return data;
        // String (will be json)
        if (typeof (data) === 'string') return JSON.parse(data);
        // Blob
        if (data instanceof Blob) return this.unpackData(await data.text());
        // Invalid...
        return null;
    }
}
